import { Link } from 'react-router-dom';
import { Button, Card } from '@/shared/ui';
import styles from './ErrorPages.module.css';

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <Card>
        <h1 className={styles.code}>404</h1>
        <p>Pagina nao encontrada.</p>
        <Link to="/">
          <Button>Voltar ao inicio</Button>
        </Link>
      </Card>
    </div>
  );
}

export function ForbiddenPage() {
  return (
    <div className={styles.page}>
      <Card>
        <h1 className={styles.code}>403</h1>
        <p>Voce nao tem permissao para acessar esta pagina.</p>
        <Link to="/">
          <Button>Voltar ao inicio</Button>
        </Link>
      </Card>
    </div>
  );
}

export function EmBrevePage() {
  return (
    <div className={styles.pageInline}>
      <Card>
        <h2>Em breve</h2>
        <p>Este modulo ainda nao foi implementado.</p>
        <Link to="/">
          <Button variant="secondary">Voltar ao inicio</Button>
        </Link>
      </Card>
    </div>
  );
}
